import React from 'react';

import {ConnectorLimitsForm} from 'src/components/connector-limits-form';
import {SaveWithReasonButton} from 'src/components/save-with-reason/save-with-reason-button';

import {LimitsTabs} from '../limits-tabs';

import {useUserConnectorLimits} from './useUserConnectorLimits';

const USER_MCP_TOOLTIP_TEXT =
    'This value displays the used limits'
    + ' vs the set limit for the tool calls per month'
    + ' for the selected user.';

type Props = {
    userId: number,
    accountId: number,
};

export const UserConnectorLimits = (
    {userId, accountId}: Props,
) => {
    const {
        isConnectorLimitsAllowed,
        ...formProps
    } = useUserConnectorLimits(userId, accountId);

    return (
        <>
            <LimitsTabs
                userId={userId}
                activeTab="connector-limits"
                isConnectorLimitsAllowed={
                    isConnectorLimitsAllowed
                }
            />
            <ConnectorLimitsForm
                {...formProps}
                saveAction={(
                    <SaveWithReasonButton
                        onSave={formProps.onSave}
                        busy={formProps.busy}
                        disabled={!formProps.anyChanged || formProps.isLoadingAny}
                    />
                )}
                tooltipText={USER_MCP_TOOLTIP_TEXT}
                dateInputId="user-temp-mcp-limits-until-date-picker"
            />
        </>
    );
};
